import { getUserLngLat } from './geo'

const safeJsonParse = (s) => {
  try {
    return JSON.parse(s)
  } catch (e) {
    return null
  }
}

const toFiniteNumber = (v) => {
  if (v === undefined || v === null || v === '') return null
  const n = Number(v)
  return Number.isFinite(n) ? n : null
}

export function saveUserLngLat(lng, lat) {
  if (typeof window === 'undefined' || !window.localStorage) return
  const _lng = toFiniteNumber(lng)
  const _lat = toFiniteNumber(lat)
  if (_lng === null || _lat === null) return

  // Keep both structured and scalar keys for maximum compatibility with existing code.
  localStorage.setItem('userGeo', JSON.stringify({ lng: _lng, lat: _lat, ts: Date.now() }))
  localStorage.setItem('lng', String(_lng))
  localStorage.setItem('lat', String(_lat))
}

// Ensure we have a usable lng/lat in cache. This is best-effort:
// - if browser denies permission / unsupported, it resolves null silently
// - if cached value is fresh, it won't prompt again
export function ensureUserLngLat(options = {}) {
  if (typeof window === 'undefined') return Promise.resolve(null)

  const maxAgeMs = typeof options.maxAgeMs === 'number' ? options.maxAgeMs : 10 * 60 * 1000
  const timeoutMs = typeof options.timeoutMs === 'number' ? options.timeoutMs : 8000
  const enableHighAccuracy = !!options.enableHighAccuracy

  // If we already have fresh cached geo, skip prompting user again.
  const cached = safeJsonParse(localStorage.getItem('userGeo') || '')
  if (cached) {
    const lng = toFiniteNumber(cached.lng)
    const lat = toFiniteNumber(cached.lat)
    const ts = toFiniteNumber(cached.ts)
    if (lng !== null && lat !== null && ts !== null && Date.now() - ts <= maxAgeMs) {
      return Promise.resolve({ lng, lat })
    }
  }

  // Also accept any existing geo from other caches.
  const existing = getUserLngLat()
  if (existing && maxAgeMs > 0) {
    // Backfill into preferred cache with a new timestamp.
    saveUserLngLat(existing.lng, existing.lat)
    return Promise.resolve(existing)
  }

  if (!navigator || !navigator.geolocation || typeof navigator.geolocation.getCurrentPosition !== 'function') {
    return Promise.resolve(null)
  }

  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const coords = pos && pos.coords ? pos.coords : {}
        const lng = toFiniteNumber(coords.longitude)
        const lat = toFiniteNumber(coords.latitude)
        if (lng !== null && lat !== null) {
          saveUserLngLat(lng, lat)
          resolve({ lng, lat })
          return
        }
        resolve(null)
      },
      () => resolve(null),
      {
        enableHighAccuracy,
        timeout: timeoutMs,
        maximumAge: maxAgeMs
      }
    )
  })
}

